export function extractReadableFileName(url: string): string {
  if (!url) return '';

  // Extract everything after the last "/"
  const lastPart = url.split('/').pop() || '';

  // Remove prefix before the actual file name (prefix ends before last "-")
  const parts = lastPart.split('-');

  // If filename is prefixed, the real name is usually the last element
  if (parts.length > 1) {
    return parts.slice(1).join('-');
  }

  // If no prefix found, return the last part as is
  return lastPart;
}

export function fileExtension(filename: string = ''): string {
  const cleanName = (filename || '').split('?')[0].split('#')[0];
  const lastPart = cleanName.split('/').pop() || cleanName;
  const lastDot = lastPart.lastIndexOf('.');

  return lastDot !== -1 ? lastPart.substring(lastDot + 1).toLowerCase() : '';
}

export function isAudioFile(filename: string = ''): boolean {
  return [
    'aac',
    'amr',
    'flac',
    'm4a',
    'mp3',
    'oga',
    'ogg',
    'opus',
    'wav',
    'weba',
    'webm',
  ].includes(fileExtension(filename));
}

export function fileMessageType(
  filename: string = '',
): 'image' | 'audio' | 'others' {
  const extension = fileExtension(filename);
  switch (extension) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'bmp':
    case 'webp':
      return 'image';
    case 'aac':
    case 'amr':
    case 'flac':
    case 'm4a':
    case 'mp3':
    case 'oga':
    case 'ogg':
    case 'opus':
    case 'wav':
    case 'weba':
    case 'webm':
      return 'audio';
    default:
      return 'others';
  }
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
}

export function priceFormat(value: string): string {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const convertToEnglishDigits = (input: any): string => {
  input = input == null ? '' : String(input);
  const faDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const arDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const enDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  // Replace Farsi digits
  faDigits.forEach((faDigit, index) => {
    input = input.replace(new RegExp(faDigit, 'g'), enDigits[index]);
  });

  // Replace Arabic digits
  arDigits.forEach((arDigit, index) => {
    input = input.replace(new RegExp(arDigit, 'g'), enDigits[index]);
  });

  // Ensure Persian/Arabic-Indic digits are also converted even if the arrays above are garbled
  input = input.replace(/[\u06F0-\u06F9\u0660-\u0669]/g, (char: string) => {
    const code = char.charCodeAt(0);
    if (code >= 0x06f0 && code <= 0x06f9) return String(code - 0x06f0);
    if (code >= 0x0660 && code <= 0x0669) return String(code - 0x0660);
    return char;
  });

  return input;
};

export function formatToman(value: any, fallback: string = '-'): string {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }

  const normalized = convertToEnglishDigits(value)
    .replace(/,/g, '')
    .trim();
  const amount = Number(normalized);

  if (!Number.isFinite(amount)) {
    return fallback;
  }

  return `${amount.toLocaleString('en-US', {
    maximumFractionDigits: 0,
  })} تومان`;
}

export const getFullName = (firstName?: string, lastName?: string) => {
  const name = [];
  if (firstName) name.push(firstName);
  if (lastName) name.push(lastName);
  return name.join(' ') || 'بدون نام';
};
